import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type infoCategoryType = 'ALL' | 'NEWS' | 'MAGAZINE';

interface IInfoCategory {
  selectedCategory: infoCategoryType;
}

const initialState: IInfoCategory = {
  selectedCategory: 'ALL',
};

export const infoCategorySlice = createSlice({
  name: 'infoCategory',
  initialState,
  reducers: {
    setSelectedCategory: (state, action: PayloadAction<infoCategoryType>) => {
      if (state.selectedCategory !== action.payload) {
        state.selectedCategory = action.payload;
      }
    },
  },
});
